export default "__VITE_ASSET__CoLe034e__"